const noop = () => {};

export { noop };
